import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './EntitySubpageQuery.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntitySubpageQueryVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
  moduleType: Types.Scalars['String']['input'];
  socialProofClickReasonsKey: Types.ClickReasonsEnum;
}>;


export type EntitySubpageQuery = (
  { __typename?: 'Query' }
  & { headerProperties?: Types.Maybe<{ __typename?: 'EntityPageAboutUsModule' } | { __typename?: 'EntityPageGenericModule' } | (
    { __typename?: 'EntityPageHeaderModule' }
    & Pick<Types.EntityPageHeaderModule, 'properties'>
  )>, moduleProperties?: Types.Maybe<{ __typename?: 'EntityPageAboutUsModule' } | (
    { __typename?: 'EntityPageGenericModule' }
    & Pick<Types.EntityPageGenericModule, 'globalId'>
  ) | { __typename?: 'EntityPageHeaderModule' }>, entityPageEX?: Types.Maybe<(
    { __typename?: 'EntityPage' }
    & Pick<Types.EntityPage, 'id' | 'slug' | 'globalId' | 'title' | 'focusType' | 'publicationStatus' | 'visibility'>
    & { context?: Types.Maybe<(
      { __typename?: 'EntityPageContext' }
      & Pick<Types.EntityPageContext, 'companyId' | 'cppId'>
    )>, contract: (
      { __typename?: 'EntityPageContract' }
      & Pick<Types.EntityPageContract, 'type'>
    ), links: (
      { __typename?: 'EntityPageLinks' }
      & Pick<Types.EntityPageLinks, 'self'>
    ), logoImage?: Types.Maybe<Array<(
      { __typename?: 'ScaledImage' }
      & Pick<Types.ScaledImage, 'reference' | 'url'>
    )>>, userPageContext?: Types.Maybe<(
      { __typename?: 'EntityPageUserContext' }
      & { userInteractions?: Types.Maybe<{ __typename: 'EntityPageUserInteractionFallback' } | (
        { __typename: 'EntityPageUserInteractionFollow' }
        & { followState?: Types.Maybe<(
          { __typename?: 'FollowContext' }
          & Pick<Types.FollowContext, 'isFollowing'>
        )> }
      ) | { __typename: 'EntityPageUserInteractionJoin' }>, permissions: (
        { __typename?: 'EntityPagePermissions' }
        & Pick<Types.EntityPagePermissions, 'canEdit' | 'canAdmin'>
      ), socialProof?: Types.Maybe<(
        { __typename?: 'EntityPageSocialProofConnection' }
        & Pick<Types.EntityPageSocialProofConnection, 'proofType' | 'total'>
        & { edges: Array<Types.Maybe<(
          { __typename?: 'EntityPageSocialProofEdge' }
          & { node?: Types.Maybe<(
            { __typename?: 'EntityPageSocialProof' }
            & { xingId?: Types.Maybe<(
              { __typename?: 'XingId' }
              & Pick<Types.XingId, 'id' | 'pageName' | 'displayName' | 'gender'>
              & { profileImage?: Types.Maybe<Array<Types.Maybe<(
                { __typename?: 'ProfileImage' }
                & Pick<Types.ProfileImage, 'url'>
              )>>>, clickReasonProfileUrl?: Types.Maybe<(
                { __typename?: 'ClickReason' }
                & Pick<Types.ClickReason, 'profileUrl'>
              )> }
            )> }
          )> }
        )>> }
      )> }
    )> }
  ) | (
    { __typename?: 'EntityPageError' }
    & Pick<Types.EntityPageError, 'errorType' | 'errorCode'>
  ) | (
    { __typename?: 'EntityPageMoved' }
    & Pick<Types.EntityPageMoved, 'slug'>
  )> }
);



/**
 * __useEntitySubpageQuery__
 *
 * To run a query within a React component, call `useEntitySubpageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitySubpageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitySubpageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      moduleType: // value for 'moduleType'
 *      socialProofClickReasonsKey: // value for 'socialProofClickReasonsKey'
 *   },
 * });
 */
export function useEntitySubpageQuery(baseOptions: Apollo.QueryHookOptions<EntitySubpageQuery, EntitySubpageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitySubpageQuery, EntitySubpageQueryVariables>(Operations.EntitySubpage, options);
      }
export function useEntitySubpageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitySubpageQuery, EntitySubpageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitySubpageQuery, EntitySubpageQueryVariables>(Operations.EntitySubpage, options);
        }
export type EntitySubpageQueryHookResult = ReturnType<typeof useEntitySubpageQuery>;
export type EntitySubpageLazyQueryHookResult = ReturnType<typeof useEntitySubpageLazyQuery>;
export type EntitySubpageQueryResult = Apollo.QueryResult<EntitySubpageQuery, EntitySubpageQueryVariables>;